import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { ICombinedStore } from './store.interface';
import { headerFooterSlice } from './headerFooter';

export const useStore = create<ICombinedStore>()(
  devtools(
    (...a) => ({
      ...headerFooterSlice(...a),
    }),
    {
      name: 'storage',
    }
  )
);
